import {
  ausschreibungsdiensteFooterData,
  baumagazinFooterData,
  evergabeFooterData,
  fachzeitschriftenFooterData,
  galabauFooterData,
  ueberUnsFooterData,
  umweltbauFooterData,
  vergabeWissenFooterData,
} from "./footer-data"

export const getFooterData = {
  ausschreibungsdienste: ausschreibungsdiensteFooterData,
  baumagazin: baumagazinFooterData,
  evergabe: evergabeFooterData,
  fachzeitschriften: fachzeitschriftenFooterData,
  galabau: galabauFooterData,
  "ueber-uns": ueberUnsFooterData,
  umweltbau: umweltbauFooterData,
  "vergabe-wissen": vergabeWissenFooterData,
}
